import React from 'react'
import Tooltip from '@mui/material/Tooltip'

const AdxToolTip = ({ children, sx, disableFocusListener = false, ...rest }) => {
  return (
    <Tooltip
      placement="bottom"
      sx={{ ...sx }}
      {...rest}
      disableFocusListener={disableFocusListener}
    >
      {children}
    </Tooltip>
  )
}

export default AdxToolTip
